<template>
  <div class="koc-card">
    <div
      v-if="showOverlay"
      class="koc-card-overlay"
      @mouseover="showOverLayText = true"
      @mouseleave="showOverLayText = false"
    >
      <div class="koc-card-overlay-tooltip">
        <Transition name="slide-fade">
          <div
            v-if="showOverLayText"
            class="koc-card-overlay-tooltip"
          >
            <div class="koc-card-overlay-tooltip-container koc-title koc-montserrat">
              <div>This feature is only available for our Pro level members.  Click <a href="https://members.kelbyone.com/upgrade">here</a> to upgrade your membership</div>
            </div>
          </div>
        </Transition>
      </div>
    </div>
    <Transition name="bounce">
      <div
        v-if="showUpdatingOverlay"
        class="koc-card-overlay"
      >
        <div class="koc-card-overlay-tooltip">
          <div class="koc-card-overlay-tooltip">
            <div class="koc-card-overlay-tooltip-container">
              <div class="koc-card-overlay-tooltip-container koc-title koc-montserrat">
                {{ updatingOverlayText }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
    <div
      v-if="$slots.header"
      class="koc-card-header"
    >
      <slot name="header" />
    </div>
    <div
      v-if="headerText && headerLink && headerLinkText"
      class="koc-card-header"
    >
      <div
        class="koc-card-header-title koc-title koc-montserrat"
        v-html="headerText"
      />
      <div class="koc-card-header-link koc-title koc-montserrat">
        <a
          :href="headerLink"
          v-html="headerLinkText"
        />
      </div>
    </div>
    <div
      v-if="$slots.image"
    >
      <slot name="image" />
    </div>
    <div
      v-if="imageLink && imageUrl"
      class="koc-card-image"
    >
      <a :href="imageLink">
        <div
          class="koc-card-image-thumbnail"
          :style="`background-image: url(${imageUrl})`"
        />
        <div
          v-if="showRibbon"
          class="koc-card-image-ribbon"
        >
          <span>New</span>
        </div>
      </a>
    </div>
    <div
      v-else-if="imageUrl"
      class="koc-card-image"
    >
      <div
        class="koc-card-image-thumbnail"
        :style="`background-image: url(${imageUrl})`"
      />
      <div
        v-if="showRibbon"
        class="koc-card-image-ribbon"
      >
        <span>New</span>
      </div>
    </div>
    <div
      v-if="$slots.content"
      class="koc-card-content"
    >
      <slot name="content" />
    </div>
    <div
      v-if="contentLink && contentTitle"
      class="koc-card-content"
    >
      <div class="koc-card-content-title koc-title koc-montserrat">
        <a
          :href="contentLink"
          v-html="contentTitle"
        />
      </div>
      <div class="koc-card-content-body">
        <p v-html="contentBody" />
      </div>
    </div>
    <div
      v-if="$slots.footer"
      :class="course ? 'koc-card-footer-course' : 'koc-card-footer'"
    >
      <slot name="footer" />
    </div>
    <div
      v-if="footerText"
      class="koc-card-footer"
    >
      <div class="koc-card-footer-link koc-title koc-montserrat">
        <a
          :href="footerLink"
          v-html="footerText"
        />
      </div>
    </div>
  </div>
</template>

<script src="./card.js"></script>
<style lang="scss" scoped src="./card.scss"></style>
